import { render, staticRenderFns } from "./GroupsManager.vue?vue&type=template&id=9c0b3032"
import script from "./GroupsManager.vue?vue&type=script&lang=js"
export * from "./GroupsManager.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports